<template>
  <div class="setting-component-page">
    <div class="setting-component-page__head">
      <div>
        <strong>{{ title }}</strong>
        <p v-if="summary">{{ summary }}</p>
      </div>
      <CButton
        type="button"
        color="secondary"
        variant="outline"
        size="sm"
        @click="back"
      >自社設定へ戻る</CButton>
    </div>

    <!--
      **部品はそのまま置く。**中の作りも保存の口も触らない。
      触ると、いま動いているログイン方法や休日カレンダーの保存に
      手を入れることになる。ここでやりたいのは置き場所を変えることだけ。
    -->
    <slot/>
  </div>
</template>

<script>
/**
 * 自社設定の一覧からたたんで追い出した部品を、1枚で出すための枠。
 *
 * <h2>なぜ枠だけなのか</h2>
 *
 * ログイン方法・管理者の2要素認証・休日カレンダー・有休付与ルールは、
 * それぞれ自分で読み書きする部品で、<b>保存の口も自分で持っている。</b>
 * ここで中身に手を入れると、動いている保存に触ることになる。
 *
 * だから枠は<b>戻り道と見出しだけ</b>を足す。部品は素のまま置く。
 */
export default {
  name: 'SettingComponentPage',

  props: {
    title: { type: String, required: true },
    summary: { type: String, default: '' }
  },

  methods: {
    back () {
      this.$router.push({ name: '設定' }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.setting-component-page__head {
  display: flex;
  align-items: flex-start;
  gap: 1rem;
  margin-bottom: 1rem;
}

.setting-component-page__head > div:first-child {
  flex: 1 1 auto;
  min-width: 0;
}

.setting-component-page__head strong {
  color: #17384d;
  font-size: 1.05rem;
}

.setting-component-page__head p {
  margin: 0.2rem 0 0;
  color: #6a7f8c;
  font-size: 0.8rem;
  line-height: 1.6;
}
</style>
